import { DialogActions as MuiDialogActions } from '@mui/material';
import { styled } from '../../utils';
const DialogActionStyled = styled(MuiDialogActions)(({ theme }) => ({
    padding: theme.spacing(3, 2, 2, 2),
    columnGap: theme.spacing(104),
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
        justifyContent: 'space-between',
        columnGap: 0,
    },
}));
export const DialogActions = DialogActionStyled;
